export const OAUTH_STORAGE_KEYS = {
  STATE: 'oauth_state',
  REDIRECT_PATH: 'auth_redirect_path',
} as const;
